import { render, staticRenderFns } from "./SuffixPieChart.vue?vue&type=template&id=780a11ba&"
import script from "./SuffixPieChart.vue?vue&type=script&lang=js&"
export * from "./SuffixPieChart.vue?vue&type=script&lang=js&"
import style0 from "./SuffixPieChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports